import { render } from "./BasicFeature.vue?vue&type=template&id=035647c3&scoped=true"
import script from "./BasicFeature.vue?vue&type=script&lang=js"
export * from "./BasicFeature.vue?vue&type=script&lang=js"

import "./BasicFeature.vue?vue&type=style&index=0&id=035647c3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035647c3"]])

export default __exports__